const getDefaultFilter = () => ({
  page: 1,
  limit: 10,
  sort: '-DC',
  offset: 0,
  search: '',
  preset: null
})

const getPresetFilters = () => ({
  preset: null
})

export default {
  namespaced: true,
  state: {
    filter: getDefaultFilter(),
    results: { items: [], totalItems: 0, totalPages: 0, currentPage: 1, perPage: 10 }
  },
  mutations: {
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1, offset: 0 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    addFilter (state, filter) {
      state.filter = { ...state.filter, ...filter, page: 1 }

      Object.keys(state.filter).forEach(key => {
        if (state.filter[key] === undefined) {
          delete state.filter[key]
        }
      })
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      state.results = { items: [], totalItems: 0, totalPages: 0, currentPage: 1, perPage: 10 }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    }
  }
}
